import {FC, useState, useEffect} from 'react'

interface LoadingProgressBarProps {
  isLoading: boolean
}

const LoadingProgressBar: FC<LoadingProgressBarProps> = ({isLoading}) => {
  const [progress, setProgress] = useState(0)

  useEffect(() => {
    if (!isLoading) {
      setProgress(0)
      return
    }

    // Reset progress when loading starts
    setProgress(10)

    // Simulate progress animation
    const interval = setInterval(() => {
      setProgress(prev => {
        if (prev >= 90) {
          return prev // Keep at 90% until loading completes
        }
        // Gradually increase progress
        return Math.min(prev + Math.random() * 15, 90)
      })
    }, 200)

    return () => clearInterval(interval)
  }, [isLoading])

  // Animate to 100% when loading is about to complete
  useEffect(() => {
    if (!isLoading && progress > 0) {
      setProgress(100)
      const timer = setTimeout(() => setProgress(0), 300)
      return () => clearTimeout(timer)
    }
  }, [isLoading, progress])

  if (!isLoading && progress === 0) return null

  return (
    <div 
      className='position-fixed top-0 start-0 w-100' 
      style={{
        zIndex: 9999, 
        top: '70px',
        left: 0,
        right: 0,
      }}
    >
      <div className='progress progress-sm h-3px' style={{borderRadius: 0, margin: 0, backgroundColor: 'transparent'}}>
        <div
          className='progress-bar progress-bar-striped progress-bar-animated bg-primary'
          role='progressbar'
          style={{
            width: `${progress}%`,
            transition: progress === 100 ? 'width 0.3s ease' : 'width 0.2s linear'
          }}
          aria-valuenow={progress}
          aria-valuemin={0}
          aria-valuemax={100}
        ></div>
      </div>
    </div>
  )
}

export {LoadingProgressBar}

